import { render } from "./PageBtn.vue?vue&type=template&id=990c30f8"
import script from "./PageBtn.vue?vue&type=script&lang=js"
export * from "./PageBtn.vue?vue&type=script&lang=js"

import exportComponent from "C:\\java\\workspace\\yonsei_tams2_web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__